import { BookmarkSortModel } from 'src/app/bookmarks/models/bookmark-sort.model';

export class SearchOptions {
    constructor(
        public query: string = '',
        public sortBy: BookmarkSortModel,
        public pageSize: number = 25,
        public offset: number = 0
    ) {}
}
